import moment from "moment";

export const dateHelper = {
    ensureMoment(date) {
        if (moment.isMoment(date)) {
            return date;
        }
        if (date instanceof Date) {
            return moment(date);
        }
        if (typeof date === 'string' || typeof date === 'number') {
            const parsedDate = moment(date);
            if (parsedDate.isValid()) {
                return parsedDate;
            }
        }
        return null; // Return null for invalid inputs
    },
    toDate(date) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.toDate();
        }
        return null;
    },
    formatDate(date, format) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.format(format);
        }
        return null;
    },
    addDay(date, amount) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.add(amount, 'days');
        }
        return null;
    },
    addMonth(date, amount) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.add(amount, 'months');
        }
        return null;
    },
    addYear(date, amount) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.add(amount, 'years');
        }
        return null;
    },
    firstDayOfMonth(date) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.startOf('month').toDate();
        }
        return null;
    },
    lastDayOfMonth(date) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.endOf('month').toDate();
        }
        return null;
    },
    isDateEarlierThanNow(date) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.isBefore(dateHelper.ensureMoment(new Date()));
        }
        return false;
    },
    isSameDate(date1, date2) {
        const _date1 = dateHelper.ensureMoment(date1);
        const _date2 = dateHelper.ensureMoment(date2);
        if(_date1 && _date2) {
            return _date1.isSame(_date2);
        }
        return false;
    },
    isBeforeDate(date1, date2) {
        const _date1 = dateHelper.ensureMoment(date1);
        const _date2 = dateHelper.ensureMoment(date2);
        if(_date1 && _date2) {
            return _date1.isBefore(_date2);
        }
        return false;
    },
    isAfterDate(date1, date2) {
        const _date1 = dateHelper.ensureMoment(date1);
        const _date2 = dateHelper.ensureMoment(date2);
        if(_date1 && _date2) {
            return _date1.isAfter(_date2);
        }
        return false;
    },
    isBetweenDate(date, startDate, endDate) {
        const _date = dateHelper.ensureMoment(date);
        const _startDate = dateHelper.ensureMoment(startDate);
        const _endDate = dateHelper.ensureMoment(endDate);

        if(_date && _startDate && _endDate) {
            return _date.isBetween(_startDate, _endDate, null, '[]') || dateHelper.isSameDate(_date, _startDate) || dateHelper.isSameDate(_date, _endDate);
        }
        return false;
    },
    isDate(date) {
        const _date = this.ensureMoment(date);
        return _date !== null && _date.isValid();
    },
    isDateInstance(date) {
        return date instanceof Date;
    },
    addMinute(date, amount) {
        const _date = dateHelper.ensureMoment(date);
        if(_date) {
            return _date.add(amount, 'minutes');
        }
        return null;
    },
}
